import { reloadOnChunkError } from 'utility/reloadOnChunkError'

export const registerPreloadErrorHandler = () => {
  const handlePreloadError = (event: Event) => {
    if (reloadOnChunkError()) event.preventDefault()
  }

  window.addEventListener('vite:preloadError', handlePreloadError)

  return () => window.removeEventListener('vite:preloadError', handlePreloadError)
}
